import { Text } from '@shared/components/Text';
import { Colors } from '@shared/styles';
import { API } from '@shared/types/api';
import { i18n } from '@shared/util/i18n';
import { MBBaseChatBanner } from './base';

interface MBDMChatBannerProps {
  user: API.ShortUserFragment;
  channel: API.ChannelFragment;
}

export function MBDMChatBanner({ user, channel }: MBDMChatBannerProps) {
  return (
    <MBBaseChatBanner title={user.fullName} subtitle={`@${user.username}`} channel={channel}>
      <Text color={Colors.v2.greenSecondary90}>
        {i18n('chat.banner.dm', { name: user.fullName })}
      </Text>
    </MBBaseChatBanner>
  );
}
